import { userRoles, globalUserRoles, associatedUserStates } from '/business/shared/util/Statics';
import DevError from '/shared/errors/DevError';
import getAssociatedUsersByRole from '/business/shared/functions/getAssociatedUsersByRole';
import getAssociatedUsersByInviteState from '/business/shared/functions/getAssociatedUsersByInviteState';
import type { AssociatedUser } from '/business/shared/functions/types';

type AcceptedUserByRole = {
  email: string | null;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  fullName: string | null;
};

function validateRole(role: string): true {
  const validRolesWithSingleAcceptedUser = [
    userRoles.REVIEWER,
    userRoles.APPROVER,
    userRoles.OWNER,
    globalUserRoles.APPLICATION_SUPPORT,
  ];

  if (!validRolesWithSingleAcceptedUser.includes(role)) {
    throw new DevError(`role must be one of ${validRolesWithSingleAcceptedUser.join(', ')}`);
  }

  return true;
}

function getAcceptedUserByRole(associatedUsers: AssociatedUser[], role: string): AcceptedUserByRole | null {
  // we want to check the supplied role is a role which can have only a single accepted user
  validateRole(role);

  const usersByRole = getAssociatedUsersByRole(associatedUsers, role);
  const acceptedUsersByRole = getAssociatedUsersByInviteState(usersByRole, associatedUserStates.ACCEPTED);
  // as there can only be a single accepted user for the given role we can grab the first item in the array of accepted users
  const acceptedUserByRole = acceptedUsersByRole[0];

  if (!acceptedUserByRole) {
    return null;
  }

  const { email = null, user = null } = acceptedUserByRole;

  const firstName = user?.firstName;
  const lastName = user?.lastName;

  let fullName: string | null = null;

  if (firstName && lastName) {
    fullName = firstName.concat(' ', lastName);
  }

  return {
    email,
    firstName,
    lastName,
    fullName,
  };
}

export default getAcceptedUserByRole;
